import axios from 'lib/axios';

class P2GTransactionService {
  async get({
    clientId,
    status,
    createdFrom,
    createdTo,
    page,
    limit,
  }: {
    clientId?: string;
    status?: 'pending' | 'paid' | 'failed' | 'expired';
    createdFrom: number;
    createdTo: number;
    page?: number;
    limit?: number;
  }) {
    const response = await axios.post('cc/p2gOrders', {
      createdFrom,
      createdTo,
      ...(clientId ? {clientId} : {}),
      ...(status ? {status} : {}),
      ...(page ? {page} : {}),
      ...(limit ? {limit} : {}),
    });
    return response.data;
  }
}

export const p2gTransactionService = new P2GTransactionService();
